<template>
	<div class="refundList">
		<back-to></back-to>
		<section class="refundList-cont">
			<div class="refundList-cont-tabs">
				<span v-for="(item,index) in tab_array" :class="item.id == current?'tabsActive':''"
					@click="tabChange(item.id)">{{item.name}}</span>
			</div>
			<div class="descript-banner">
				<span @click="dialog">
					<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/WechatIMG23.png" alt="">
					<p class="descript-banner-title">退款流程说明</p>
				</span>
			</div>
			<!-- 列表 -->
			<div class="refundList-cont-list">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
					:immediate-check="false" class="refundList-cont-lists">
					<ul>
						<li class="refundList-cont-lists-item" v-for="(item,index) in list">
							<span class="refundList-cont-lists-itemt">
								<p>景点门票</p>
								<p>{{item.orderNo}}</p>
							</span>
							<span class="refundList-cont-lists-itemc">
								<img v-lazy="item.showPic" />
								<span>
									<p>{{item.title}}</p>
									<p>￥{{item.price}}</p>
								</span>
							</span>
							<span class="refundList-cont-lists-itemb">
								<p v-if="current == 1" @click="clickApply(item)">申请退款</p>
								<p v-else @click="clickApply(item)">查看详情</p>
							</span>
						</li>
					</ul>
				</van-list>
			</div>

		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	import {
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		name: 'refundList',
		components: {
			BackTo
		},
		data() {
			return {
				loading: false,
				finished: false,
				pageIndex: 1,
				organizationId: 1,
				list: [],
				current: 1,
				tab_array: [{
						name: "可申请",
						id: "1"
					},
					{
						name: "待审核",
						id: "2"
					},
					{
						name: "审核通过",
						id: "3"
					},
					{
						name: "审核未通过",
						id: "4"
					}
				],
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getList()
		},
		methods: {
			...mapMutations('account', ['setRefundApplyDetail']),
			clickApply(data) {
				this.setRefundApplyDetail(data)
				this.$router.push({
					path: '/refundDetail',
					query: {
						id: data.id,
						current: this.current,
						type: this.$route.query.type
					}
				})
			},
			tabChange(e) {
				console.log(e)
				if (e == this.current) {
					return
				}
				this.current = e
				window.scrollTo(0, 0)
				this.loading = false,
					this.finished = false,
					this.pageIndex = 1
				this.getList(true)
			},
			dialog() {
				Dialog.alert({
					title: '退款流程说明',
					message: '1.不同门票有不同退改政策，请根据各景区门票下方的退改说明进行相应操作。<br/>2.不同门票退款审核时间不一样，一般会在2个工作日内审核完成.<br/>3.退款款项均原路返回，如果使用银行卡支付退款到账时间会在1-3日内，微信退款到账会在1日内。<br/>4.特殊情况请及时联系客服，我们会在第一时间给予解答。',
				})
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				if (this.$route.query.type == 1) {
					var url = '/NTRefund/Post_GetRefundListForUser'
					var data = {
						"OrganizationId": this.$organizationId,
						"userId": this.userInfo.userId,
						"statusId": this.current,
						"source": 1,
						"skipCount": this.pageIndex,
						"maxResultCount": 10
					}
				} else {
					var url = '/TeamOrder/Post_TeamOrderRefundByUserListAsync'
					var data = {
						"index": this.pageIndex,
						"pageSize": 10,
						"userId": this.userInfo.userId,
						"statusId": this.current
					}
				}

				this.$_postNew(
					this.$severOrder + url, data
				).then(res => {
					console.log(res.result)
					if (e) {
						this.list = res.result.refunds
					} else {
						this.list = this.list.concat(res.result.refunds)
					}
					if (res.result.refunds.length < 10) {
						this.finished = true;
					}
				})
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style>
	.refundList-cont {
		width: 100%;
		margin-top: @nav-bar-height;
	}

	.refundList-cont-tabs {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: fixed;
		top: @nav-bar-height;
		height: 100px;
		width: 100%;
		background-color: #fff;
		z-index: 33;

	}

	.refundList-cont-tabs span {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #666;
		font-size: 28px;
	}

	.tabsActive {
		color: #ff6d00 !important;
		font-weight: bold;
	}

	.descript-banner {
		width: 100%;
		padding: 0 32px;
		padding-top: 120px;
		box-sizing: border-box;
		font-size: 30px;
	}

	.descript-banner span {
		background-color: #fff;
		display: flex;
		height: 96px;
		align-items: center;
		width: 100%;
		border-radius: 24px;
	}

	.descript-banner img {
		margin: 0 20px 0 30px;
		width: 38px;
		height: 38px;
	}

	.refundList-cont-list {
		width: 100%;
		padding: 32px;
		box-sizing: border-box;
	}

	.refundList-cont-lists-item {
		width: 100%;
		background-color: #fff;
		border-radius: 24px;
		margin-bottom: 20px;
		padding: 0 30px 30px 30px;
		box-sizing: border-box;
	}

	.refundList-cont-lists-itemt {
		display: flex;
		align-items: center;
		display: flex;
		height: 100px;
		align-items: center;
	}

	.refundList-cont-lists-itemt p:first-child {
		position: relative;
		padding-right: 16px;
		font-size: 30px;
		font-weight: bold;
		color: #333;
	}

	.refundList-cont-lists-itemt p:last-child {
		margin-left: 16px;
		color: #999;
		font-size: 26px;
	}

	.refundList-cont-lists-itemt p:first-child::after {
		content: "";
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
		width: 1px;
		height: 28px;
		background-color: #999;
	}

	.refundList-cont-lists-itemc {
		display: flex;
		font-size: 30rx;

	}

	.refundList-cont-lists-itemc span p:first-child {
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.refundList-cont-lists-itemc span p:last-child {
		margin-top: 20px;
		color: #ff6d00;

	}

	.refundList-cont-lists-itemc img {
		width: 160px;
		height: 160px;
		border-radius: 10px;
		margin-right: 14px;
	}

	.refundList-cont-lists-itemb {
		width: 100%;
		margin-top: 30px;
	}

	.refundList-cont-lists-itemb p {
		width: 156px;
		height: 48px;
		text-align: center;
		line-height: 48px;
		font-size: 28px;
		color: #ff6d00;
		border: 1px solid #ff6d00;
		border-radius: 24px;
		margin-left: auto;
	}
</style>